import {
  ObjectCondition,
  ObjectTrigger,
  SceneDimmerPowerState,
  SceneDimmerState,
  SceneStateComparer,
} from '@/../client-generator/generated-clients/plants';
import EnumToRadioButton from '@/views/components/EnumToRadioButton/EnumToRadioButton.vue';
import { Options } from 'vue-class-component';
import SceneTriggerAndConditionGeneral from '../SceneTriggerAndConditionGeneral';

@Options({
  name: 'TriggerAndConditionLightDimmer',
  components: {
    EnumToRadioButton,
  },
  watch: {
    'triggerOrActionToAdd.dimmerState': function () {
      this.dimmerStateChanged();
    },
    'triggerOrActionToAdd.stateComparer': function () {
      this.stateComparerChanged();
    },
  },
})
export default class TriggerAndConditionLightDimmer extends SceneTriggerAndConditionGeneral {
  SceneDimmerState = SceneDimmerState;
  SceneStateComparer = SceneStateComparer;
  SceneDimmerPowerState = SceneDimmerPowerState;
  declare triggerOrActionToAdd: ObjectTrigger | ObjectCondition;
  static readonly MinimumDimmerPercent = 1;

  get sceneStateComparerDisabledChoices() {
    const choices: SceneStateComparer[] = [];
    if (this.triggerOrActionToAdd.dimmerState !== SceneDimmerState.Dimmer) {
      choices.push(
        SceneStateComparer.Higher,
        SceneStateComparer.Different,
        SceneStateComparer.Lower
      );
    }
    return choices;
  }

  get isDimmerManagementAvailable() {
    return (
      this.triggerOrActionToAdd.dimmerState == SceneDimmerState.Dimmer &&
      this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None
    );
  }
  get isPowerManagementAvailable() {
    return (
      this.triggerOrActionToAdd.dimmerState == SceneDimmerState.Power &&
      this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None
    );
  }

  get isConfirmEnabled() {
    switch (this.triggerOrActionToAdd.dimmerState) {
      case SceneDimmerState.Dimmer: {
        return (
          this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None
        );
      }
      case SceneDimmerState.Power: {
        return (
          this.triggerOrActionToAdd.stateComparer != SceneStateComparer.None &&
          this.triggerOrActionToAdd.dimmerPowerState !=
            SceneDimmerPowerState.None
        );
      }
      case SceneDimmerState.None: {
        return false;
      }
    }
  }

  dimmerStateChanged() {
    this.triggerOrActionToAdd.stateComparer = SceneStateComparer.None;
  }

  stateComparerChanged() {
    this.triggerOrActionToAdd.dimmerPowerState = SceneDimmerPowerState.None;
    this.triggerOrActionToAdd.dimmerPercent =
      TriggerAndConditionLightDimmer.MinimumDimmerPercent;
  }
}
